import React, { Component } from "react";
import { Button, Alert } from "antd";
import LoadingIndicator from "../shared/LoadingIndicator/LoadingIndicator";
import TopCountriesTable from "./TopCountriesTable";
import TldDistributionTable from "./TldDistributionTable";
import TopAnchorsTable from "./TopAnchorsTable";
import ReferringDomainsTable from "./ReferringDomainsTable";
import BacklinksTable from "./BacklinksTable";
import ExportAsFile from "../shared/ExportAsFile/ExportAsFile";
import IconLabel from "../shared/IconLabel/IconLabel";

class BacklinksResults extends Component {
  render() {
    const { resourceType, isLoading, isFirstFetch, results, hasMore, onLoadMore } = this.props;

    if (isFirstFetch) {
      return <LoadingIndicator />;
    }

    return results.length
      ? <div className="backlinks-results">
          {resourceType === "backlinks" && <BacklinksTable dataSource={results} />}
          {resourceType === "referring_domains" && <ReferringDomainsTable dataSource={results} />}
          {resourceType === "top_anchors" && <TopAnchorsTable dataSource={results} />}
          {resourceType === "tld_distribution" && <TldDistributionTable dataSource={results} />}
          {resourceType === "top_countries" && <TopCountriesTable dataSource={results} />}

          {hasMore
            ? <Button className="load-more" type="primary" loading={isLoading} onClick={onLoadMore}>
                Load more
              </Button>
            : null}

          <div className="export-buttons">
            <ExportAsFile fileContent={this.props.backlinksAsCsv} fileName={`${resourceType}.csv`} fileMime="text/csv">
              <Button className="light-text">
                <IconLabel icon="download" label="Export CSV" />
              </Button>
            </ExportAsFile>

            <ExportAsFile
              fileContent={this.props.backlinksAsJson}
              fileName={`${resourceType}.json`}
              fileMime="application/json">
              <Button className="light-text">
                <IconLabel icon="download" label="Export JSON" />
              </Button>
            </ExportAsFile>
          </div>
        </div>
      : <Alert message="Your domain has no indexed backlinks!" />;
  }
}

export default BacklinksResults;
